export const INTEGRATION_TYPE = 'google-dv360-outbound'
export const DATA_TYPE_KEY = 'data_type'

export const DATA_TYPES = [
  {
    type: 'campaigns',
    label: 'Campaigns',
  },
  {
    type: 'creatives',
    label: 'Creatives',
  },
  {
    type: 'advertisers',
    label: 'Advertisers',
  },
  {
    type: 'line_items',
    label: 'Line Items',
  },
  {
    type: 'insertion_orders',
    label: 'Insertion Orders',
  },
] as const
